import * as z from "zod";

export const SESSION_PATH = "/api/session";
export const READER_SESSION_PATH = "/reader-session";

// A bookmark landing names no reader: the SPA gates whichever reader the
// first session answer names, read from the URL once at load, so a reader
// id never appears in a URL.
export const VIA_PARAM = "via";
export const VIA_BOOKMARK = "bookmark";
// Rides the reader entry's returnTo so the landing knows what was just
// tried, without naming a reader: a session that still answers signed out
// is not sent round again, and a device reader coming back is gated.
export const AUTO_START_PARAM = "auto";
export const AUTO_START_DEVICE = "device";
export const AUTO_START_NEW = "new";
// A reader picked by name from the device's list lands ungated.
export const AUTO_START_CHOSEN = "chosen";

// `serverTime` (epoch ms) lets the client measure its clock skew for
// bookmark timestamps without a second request. `linked` says whether any
// account holds the reader; null when the token cannot say (minted before
// the claim, or the broker could not read it) or no reader is named.
// `isAide` is never true for a reader_session: a reader token carries no
// credential, so it can never vouch for a staff role.
export const sessionAnswerSchema = z.discriminatedUnion("lane", [
  z.object({
    lane: z.literal("reader_session"),
    readerId: z.uuid(),
    linked: z.boolean().nullable(),
    isAide: z.literal(false),
    serverTime: z.number(),
  }),
  z.object({
    lane: z.literal("user_session"),
    readerId: z.uuid().nullable(),
    linked: z.boolean().nullable(),
    isAide: z.boolean(),
    serverTime: z.number(),
  }),
]);

export type SessionAnswer = z.infer<typeof sessionAnswerSchema>;
